/**
 * @ngdoc Directive
 * @name vrm-filter-bar
 * @example
 *
 *  <vrm-filter-bar
        dropdown-filter="dropdownFilter"
        clear-filter-bar-values="clearFilterBarValues"
        apply-filter="applyFilter"
        done-filter="doneFilter"
        before-render="beforeRenderFilterBar"
    ></vrm-filter-bar>
 *
 */

(function() {
    'use strict';

    angular.module('vrm.components')
        .directive('vrmFilterBar', vrmFilterBar);

    /* @ngInject */
    function vrmFilterBar($log, vrmConfig) {

        var definition = {
            scope: {
                dropdownFilter: "=",
                clearFilterBarValues: "=",
                applyFilter: "=",
                doneFilter: "=",
                beforeRender: "=",
            },
            restrict: 'E',
            template: require('@/angular/modules/vrm-components/filterBar/filterBar.template.html'),
            link: link
        };

        return definition;

        function link($scope) {
            $scope.beforeRender && $scope.beforeRender();
            // to force the buttons to be at the end
            // +1 (buttons)
            $scope.rest = ($scope.dropdownFilter.length + 1) % 4;
        }
    }

})();
